import AdminTableDetals from "./admin-table-detatils";

export default AdminTableDetals;